__turbopack_context__.v({
  "timeText": "Ko_vAq_timeText",
  "timeTextContainer": "Ko_vAq_timeTextContainer",
});
